// extracted by mini-css-extract-plugin
export var medicalExpertsLink = "blog-entry-module--medical-experts-link--99b3e";
export var root = "blog-entry-module--root--36240";